
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { useLanguage } from "@/components/LanguageContext";
import { useLanguagePath } from "@/utils/language";
export const Footer = () => {
  const {
    language,
    t
  } = useLanguage();
  const {
    getPath
  } = useLanguagePath();
  const location = useLocation();
  const navigate = useNavigate();
  const handleNavItemClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const currentPath = location.pathname;
    const homePath = getPath('/');
    const isHome = currentPath === homePath;
    if (isHome) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      navigate(getPath(`/#${id}`));
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth"
          });
        }
      }, 100);
    }
  };

  // Define translation keys
  const translationKeys = {
    about: {
      title: language === 'pt' ? 'Sobre Nós' : 'About Us',
      text: language === 'pt' ? 'Ajudamos personal trainers a expandir seus negócios com tecnologia inovadora.' : 'We help personal trainers grow their businesses with innovative technology.'
    },
    usefulLinks: {
      title: language === 'pt' ? 'Links Úteis' : 'Useful Links',
      features: language === 'pt' ? 'Funcionalidades' : 'Features',
      benefits: language === 'pt' ? 'Vantagens' : 'Benefits',
      pricing: language === 'pt' ? 'Preços' : 'Pricing',
      testimonials: language === 'pt' ? 'Testemunhos' : 'Testimonials',
      privacy: language === 'pt' ? 'Política de Privacidade' : 'Privacy Policy',
      terms: language === 'pt' ? 'Termos de Uso' : 'Terms of Use'
    },
    contact: {
      title: language === 'pt' ? 'Contato' : 'Contact'
    },
    social: {
      title: language === 'pt' ? 'Redes Sociais' : 'Social Media'
    },
    copyright: language === 'pt' ? '© 2026 TrainerFOLIO. Todos os direitos reservados.' : '© 2026 TrainerFOLIO. All rights reserved.'
  };
  return <footer id="contact" className="bg-black text-baby-powder py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex flex-col items-start mb-4">
            <Link to={getPath("/")} className="mb-4">
              <img 
                src="/lovable-uploads/a0ac6ad1-1a90-4726-9a01-65aaa671437c.png" 
                alt="Trainerfolio Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <h3 className="text-lg font-semibold">{translationKeys.about.title}</h3>
          </div>
          <p className="text-slate-gray-light">
            {translationKeys.about.text}
          </p>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">{translationKeys.usefulLinks.title}</h3>
          <ul className="space-y-2">
            <li>
              <Link to={getPath("/features")} className="text-slate-gray-light hover:text-flame transition-colors">
                {translationKeys.usefulLinks.features}
              </Link>
            </li>
            <li>
              <Link to={getPath("/benefits")} className="text-slate-gray-light hover:text-flame transition-colors">
                {translationKeys.usefulLinks.benefits}
              </Link>
            </li>
            <li>
              <Link to={getPath("/pricing")} className="text-slate-gray-light hover:text-flame transition-colors">
                {translationKeys.usefulLinks.pricing}
              </Link>
            </li>
            <li>
              <Link to={getPath("/testimonials")} className="text-slate-gray-light hover:text-flame transition-colors">
                {translationKeys.usefulLinks.testimonials}
              </Link>
            </li>
            <li>
              <Link to={getPath("/privacy")} className="text-slate-gray-light hover:text-flame transition-colors">
                {translationKeys.usefulLinks.privacy}
              </Link>
            </li>
            <li>
              <Link to={getPath("/terms")} className="text-slate-gray-light hover:text-flame transition-colors">
                {translationKeys.usefulLinks.terms}
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">{translationKeys.contact.title}</h3>
          <ul className="space-y-2">
            <li className="text-slate-gray-light">info@trainerfolio.com</li>
          </ul>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">{translationKeys.social.title}</h3>
          <div className="flex space-x-5">
            <a href="https://instagram.com/trainerfolio" target="_blank" rel="noopener noreferrer" className="text-slate-gray-light hover:text-flame transition-colors">
              <Instagram size={20} />
              <span className="sr-only">Instagram</span>
            </a>
            <a href="https://facebook.com/trainerfolio" target="_blank" rel="noopener noreferrer" className="text-slate-gray-light hover:text-flame transition-colors">
              <Facebook size={20} />
              <span className="sr-only">Facebook</span>
            </a>
            <a href="https://twitter.com/trainerfolio" target="_blank" rel="noopener noreferrer" className="text-slate-gray-light hover:text-flame transition-colors">
              <Twitter size={20} />
              <span className="sr-only">X (Twitter)</span>
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-gray-dark/50 mt-8 pt-8">
        <div className="flex justify-center items-center text-slate-gray-light">
          <p>{translationKeys.copyright}</p>
        </div>
      </div>
    </div>
  </footer>;
};
